import React from "react";

export default function MSAccess_Left() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Left</h1>
      <p>This is the MSAccess_Left component generated from the SQL JSON.</p>
    </div>
  );
}
